import { useState } from 'react';
import type { KeyboardEvent } from 'react';
import styles from './Interactive.module.css';

interface NumericConfig {
  unit?: string;
  decimalPlaces?: number;
}

interface NumericProps {
  config?: NumericConfig;
  onSubmit: (answer: string) => void;
  disabled: boolean;
  showResult: boolean;
  isCorrect?: boolean;
}

export function Numeric({ config, onSubmit, disabled, showResult, isCorrect }: NumericProps) {
  const [value, setValue] = useState('');

  const handleSubmit = () => {
    if (disabled || !value.trim()) return;
    onSubmit(value.trim());
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  const getInputClass = () => {
    let className = `${styles.textInput} ${styles.numericInput}`;
    if (showResult) {
      className += isCorrect ? ` ${styles.correct}` : ` ${styles.incorrect}`;
    }
    return className;
  };

  return (
    <div className={styles.inputContainer}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="number"
          className={getInputClass()}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="?"
          disabled={disabled}
          step={config?.decimalPlaces ? Math.pow(10, -config.decimalPlaces) : 'any'}
          autoFocus
        />
        {config?.unit && <span className={styles.unitLabel}>{config.unit}</span>}
      </div>

      {!showResult && (
        <button
          className={styles.submitButton}
          onClick={handleSubmit}
          disabled={disabled || !value.trim()}
        >
          Submit Answer
        </button>
      )}
    </div>
  );
}
